import React from 'react'

import { Modal, ModalBody, ModalHeader } from '@clientbase/clientbase-library'
import { Stack, Typography } from '@mui/material'

import IconContainer from 'components/IconContainer/IconContainer'

interface ModalContaAzulDetailProps {
  open: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
}

// Shell do modal de detalhe da sincronização com o Conta Azul (Modal + header padrão). O
// conteúdo é responsável pelo próprio `ModalContent` (e `ModalFooter`, quando tem ações),
// seguindo o padrão dos modais de detalhe do sistema. Acionado pelo item "Conta Azul" do
// menu "..." e reusa o mesmo conteúdo (ContaAzulSection / tabela por ciclo).
const ModalContaAzulDetail: React.FC<ModalContaAzulDetailProps> = ({
  open,
  onClose,
  title = 'Conta Azul',
  children
}) => (
  <Modal
    open={open}
    handleClose={onClose}
    disablePortal={false}
    width="720px"
    maxWidth="90vw"
    maxHeight="90vh"
    height="auto"
  >
    <ModalBody>
      <ModalHeader onClose={onClose}>
        <Stack direction="row" alignItems="center" gap={2}>
          <IconContainer icon="link" />
          <Typography variant="mdBold">{title}</Typography>
        </Stack>
      </ModalHeader>
      {children}
    </ModalBody>
  </Modal>
)

export default ModalContaAzulDetail
